export const SPECS = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  StopSendingOriginInCheckoutUrl: 'specs.ecom.StopSendingOriginInCheckoutUrl',
  CallCartV2FromCartComponents: 'specs.ecom.CallCartV2FromCartComponents',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  ShowCheckoutOnEditorPreview: 'specs.ecom.ShowCheckoutOnEditorPreview',
  CouponAlignmentInCartAndCheckout: 'specs.ecom.CouponAlignmentInCartAndCheckout',
  FixCouponErrorInCart: 'specs.ecom.FixCouponErrorInCart',
  UsePartialLineItemUrlInCart: 'specs.ecom.UsePartialLineItemUrlInCart',
  FixCartNavigationOnPreview: 'specs.ecom.FixCartNavigationOnPreview',
  RevampDiscountsInCartAndCheckout: 'specs.ecom.RevampDiscountsInCartAndCheckout',
  ShowCrossedOutPriceOnLineItemLevel: 'specs.ecom.ShowCrossedOutPriceOnLineItemLevel',
  UpdateCartIconsSVGViewer: 'specs.ecom.UpdateCartIconsSVGViewer',
  CheckoutButtonWithHrefInCart: 'specs.ecom.CheckoutButtonWithHrefInCart',
  DontHandleCheckoutNotAllowedInCart: 'specs.ecom.DontHandleCheckoutNotAllowedInCart',
  CartItemQuantityBadge: 'specs.ecom.CartItemQuantityBadge',
  UseLineItemDiscountInCartSummary: 'specs.ecom.UseLineItemDiscountInCartSummary',
  ShowAdditionalFeesInSideCart: 'specs.ecom.ShowAdditionalFeesInSideCart',
  ResponsiveCart: 'specs.ecom.ResponsiveCart',
  DisplayCheckoutErrorModalsForExpressButtons: 'specs.ecom.DisplayCheckoutErrorModalsForExpressButtons',
  FixCheckoutButtonAriaLabel: 'specs.ecom.FixCheckoutButtonAriaLabel',
  RemovePmNameErrorModal: 'specs.ecom.RemovePmNameErrorModal',
  HideSubscriptionBillingPeriodWhenProductPeriodNotAligned:
    'specs.ecom.HideSubscriptionBillingPeriodWhenProductPeriodNotAligned',
  CartValidationsInCheckout: 'specs.ecom.CartValidationsInCheckout',
  SendRemoveLineItemAnalyticsFromCart: 'specs.ecom.SendRemoveLineItemAnalyticsFromCart',
} as const;
